import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EmployeeTracking } from '@/components/employee/tracking';

const trackingDetailSearchSchema = z.object({
  date: z.string().optional(), // YYYY-MM-DD
  from: z.string().optional(), // path to navigate back to (encoded)
});

export const Route = createFileRoute('/(app)/company/tracking/$employeeId')({
  component: TrackingDetailRoute,
  validateSearch: trackingDetailSearchSchema,
});

function TrackingDetailRoute() {
  const { employeeId } = Route.useParams();
  const employeeIdNum = Number(employeeId);
  return (
    <EmployeeTracking 
      employeeId={employeeIdNum}
      showBackButton
      backPath="/company/tracking"
    />
  );
}
